var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.955078H513V342.959H0V0.955078Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.955078H170.996V342.959H0V0.955078Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.004 0.955078H513V342.959H342.004V0.955078ZM214.68 199.832L181.222 149.648L214.679 99.4631L248.136 149.648L214.68 199.832ZM298.321 199.832L264.865 149.648L298.321 99.4631L331.779 149.648L298.321 199.832ZM256.5 266.745L223.044 216.56L256.5 166.376L289.957 216.56L256.5 266.745Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.957031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVc);
export default __webpack_public_path__ + "static/media/VC.9c8804a10c5371305183227080186db1.svg";
export { ForwardRef as ReactComponent };